import React, { useMemo, useState } from 'react';
import { SelectButton } from 'primereact/selectbutton';
import { EmptyState } from '../common/PageHeader';
import { NIVO } from './format';

/** kontrole pre podnošenja zahteva: greške (npr. prepisani meseci, km ne odgovaraju tahografu), upozorenja (+5%, nema km), napomene */
export default function Kontrole({ kontrole }) {
    const [nivo, setNivo] = useState('sve');
    const broj = useMemo(() => Object.keys(NIVO).reduce((o, k) => ({ ...o, [k]: kontrole.filter((x) => x.nivo === k).length }), {}), [kontrole]);
    const opcije = [{ label: `Sve (${kontrole.length})`, value: 'sve' }, ...Object.entries(NIVO).map(([k, v]) => ({ label: `${v.label} (${broj[k]})`, value: k }))];
    const lista = nivo === 'sve' ? kontrole : kontrole.filter((x) => x.nivo === nivo);
    if (!kontrole.length) return <EmptyState icon="pi pi-check-circle" title="Nema primedbi" text="Za izabrani kvartal kontrola nije našla ništa sporno." />;
    return (
        <div className="akc-kontrole">
            <SelectButton value={nivo} options={opcije} onChange={(e) => e.value && setNivo(e.value)} />
            <ul className="akc-lista">
                {lista.map((k, i) => (
                    <li key={i} className={`akc-stavka ${NIVO[k.nivo].cls}`}>
                        <i className={NIVO[k.nivo].icon} aria-hidden="true" />
                        <span><span className="visually-hidden">{NIVO[k.nivo].label}: </span>{k.poruka}</span>
                    </li>
                ))}
            </ul>
        </div>
    );
}
